import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SessionStore } from '@/app/core/state/session-store';

/**
 * ASM-only route guard. Allows the route only for back-office (ASM) users;
 * external customer-scoped users are turned away. Mirrors {@link permissionGuard}
 * but keys off the id-token `isASM` claim instead of a permission.
 */
export const asmGuard: CanActivateFn = () => {
  const session = inject(SessionStore);
  return session.isAsmResolved();
};
